<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip1230)">
      <path
          d="M11 5H16V3C16 1.74972 15.2725 1 14 1H2C0.727531 1 0 1.74972 0 3V12C0 13.2503 0.727531 14 2 14H14C15.2725 14 16 13.2503 16 12V10H11C9.72753 10 9 8.75028 9 7.5C9 6.24972 9.72753 5 11 5Z"
          fill="currentColor"/>
      <path
          d="M12 6C10.5 6 10 6.5 10 7.5C10 8.5 10.5 9 12 9H16.0009V6.00003L12 6ZM12.5 8H11.5C11.2451 8 11 7.77611 11 7.5C11 7.22389 11.2451 7 11.5 7H12.5C12.7549 7 13 7.22389 13 7.5C13 7.77611 12.7549 8 12.5 8Z"
          fill="currentColor"/>
    </g>
    <defs>
      <clipPath id="clip1230">
        <rect width="16" height="16" fill="white"/>
      </clipPath>
    </defs>
  </svg>

</template>

<script>
export default {
  name: "IconWallet"
}
</script>

<style scoped>

</style>